import axios from "axios";
import { ip_back } from "../../config";

const getToken = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: getToken() } });
const base = () => `${String(ip_back || "").replace(/\/?$/, "/")}`;

export async function fetchChatPeers({ as = "player", grId = null, clubId = null, days = 14 } = {}) {
  const res = await axios.get(`${base()}api/digiping/chat/peers`, {
    ...headers(),
    params: { as, gr_id: grId || undefined, club_id: clubId || undefined, days },
  });
  return res.data?.data || { players: [], groups: [], coach: null, unread_total: 0 };
}

export async function fetchChatHistory({
  threadKind = "dm",
  peerId = null,
  grId = null,
  limit = 200,
} = {}) {
  const res = await axios.get(`${base()}api/digiping/chat/history`, {
    ...headers(),
    params: {
      thread_kind: threadKind,
      peer_id: peerId || undefined,
      gr_id: grId || undefined,
      limit,
    },
  });
  return res.data?.data || [];
}

export async function sendChatMessage(body) {
  const res = await axios.post(`${base()}api/digiping/chat/send`, body, headers());
  return res.data?.data || null;
}

export async function markChatRead(body) {
  const res = await axios.post(`${base()}api/digiping/chat/read`, body, headers());
  return res.data?.data || null;
}

export async function fetchChatUnread() {
  const res = await axios.get(`${base()}api/digiping/chat/unread`, headers());
  return res.data?.data || { total: 0, dm: {}, group: {} };
}

export async function suggestSmartEvent(eventId, lang = "en") {
  const res = await axios.post(
    `${base()}api/digiping/smart-events/${encodeURIComponent(eventId)}/suggest`,
    { lang },
    headers()
  );
  return res.data?.data || null;
}

export async function fetchSmartEventsBrief(lang = "en", { clubId = null } = {}) {
  const res = await axios.get(`${base()}api/digiping/smart-events/brief`, {
    ...headers(),
    params: { lang, club_id: clubId || undefined },
  });
  return res.data?.data || { text: "", count: 0, items: [] };
}

export async function fetchCoachOpenBrief(lang = "en", { clubId = null } = {}) {
  const res = await axios.post(
    `${base()}api/digiping/smart-events/coach-open-brief`,
    { lang, club_id: clubId || undefined },
    headers()
  );
  return (
    res.data?.data || {
      count: 0,
      summaryText: "",
      firstAnalysis: null,
      items: [],
    }
  );
}
